import type { BadgeTone } from '@/components/ui/Badge';
import type { NotificationLabelColor } from '@coreltb/shared/constants';

/** Kolor etykiety → ton etykiety (Badge) i kropka (dzwonek, wybór koloru). */
export const LABEL_TONE: Record<NotificationLabelColor, BadgeTone> = {
  red: 'danger',
  amber: 'warning',
  green: 'success',
  blue: 'info',
  violet: 'violet',
};

export const LABEL_DOT: Record<NotificationLabelColor, string> = {
  red: 'bg-red-500 dark:bg-red-400',
  amber: 'bg-amber-500 dark:bg-amber-400',
  green: 'bg-emerald-500 dark:bg-emerald-400',
  blue: 'bg-blue-500 dark:bg-blue-400',
  violet: 'bg-violet-500 dark:bg-violet-400',
};
